module.exports = __webpack_public_path__ + "img/logo-uuva-cloud-small.950915ea.png";